<template>
  <div>
    <Form ref="searchForm" :label-width="80" :model="formCustom" inline>
      <Form-item label="用户账号：" prop="userName">
        <Input v-model="formCustom.userName" clearable placeholder="请输入" style="width: 200px"></Input>
      </Form-item>
      <Form-item label="开始日期：" prop="startTime">
        <DatePicker v-model="formCustom.startTime" placeholder="请选择" placement="bottom-end" style="width: 200px"
                    type="date" @on-change='changeStartTime'></DatePicker>
      </Form-item>
      <Form-item label="结束日期：" prop="endTime">
        <DatePicker v-model="formCustom.endTime" placeholder="请选择" placement="bottom-end" style="width: 200px"
                    type="date" @on-change='changeEndTime'></DatePicker>
      </Form-item>
      <Form-item>
        <Button type="primary" @click="handleSearch">查询</Button>
        <Button class="iviewButton" @click="handleReset('searchForm')">重置</Button>
      </Form-item>
    </Form>
    <div>
      <Table :columns="loginLogColumns" :data="loginLogTableData" :loading="loading" aria-describedby=""
             aria-hidden="true" border>
      </Table>
      <Page ref="pages" :current="page" :total="total" class="page_position" show-elevator show-sizer show-total
            @on-change="setCurrent" @on-page-size-change="setPage"></Page>
    </div>
  </div>
</template>

<script>
import {loginLogClean, loginLogDelete, loginLogPage} from '@/api/authority'
import permissionList from '@/libs/handlePermission.ts'

export default {
  name: 'loginLog',
  data() {
    return {
      total: 0,
      page: 1,
      size: 10,
      pageSize: 10,
      loading: false, // 表格等待
      btnList: [],
      formCustom: {
        userName: '',
        startTime: '',
        endTime: ''
      },
      loginLogColumns: [
        {title: '访问时间', key: 'createTime', width: '180', align: 'center'},
        {title: '用户账号', key: 'userName', align: 'center'},
        {title: '用户账号类型', key: 'userType', align: 'center'},
        {title: '登录IP地址', key: 'ipaddr', align: 'center'},
        {title: '登录状态', key: 'status', align: 'center'},
        {title: '操作信息', key: 'msg', align: 'center'},
        // { title: '操作', slot: 'action', width: '160', align: 'center', fixed: 'right' }
      ],
      loginLogTableData: [] // 表格数据
    }
  },
  mounted() {
    const list = JSON.parse(localStorage.getItem('routerList'))
    // eslint-disable-next-line new-cap
    this.btnList = new permissionList(list, this.$route.path).getList()
    this.init()
  },
  methods: {
    // 初始化
    async init() {
      this.loading = true
      loginLogPage({
        current: 1,
        size: 10
      }).then((res) => {
        this.changeData(res)
      })
    },
    // 调接口获取表格数据
    changeData(res) {
      this.total = res.data.data.total
      this.size = res.data.data.size
      this.loginLogTableData = res.data.data.records
      this.loginLogTableData.forEach((element, index) => {
        switch (element.status) {
          case '0':
            this.loginLogTableData[index].status = '成功'
            break;
          case '1':
            this.loginLogTableData[index].status = '失败'
            break;
          default:
            break;
        }
        switch (element.userType) {
          case 0:
            this.loginLogTableData[index].userType = '企业用户账号'
            break;
          case -1:
            this.loginLogTableData[index].userType = '未知角色'
            break;
          default:
            break;
        }
      });
      this.loading = false
    },
    // 查询
    handleSearch() {
      this.loading = true
      loginLogPage({
        current: 1,
        size: this.pageSize,
        userName: this.formCustom.userName,
        startTime: this.formCustom.startTime,
        endTime: this.formCustom.endTime
      }).then((res) => {
        this.changeData(res)
        this.$refs['pages'].currentPage = 1 // 分页变成第一页
      })
    },
    // 重置
    handleReset(name) {
      this.$refs[name].resetFields()
      // 重置查询条件会再次查询
      this.handleSearch()
    },
    changeStartTime(val) {
      this.formCustom.startTime = val
    },
    changeEndTime(val) {
      this.formCustom.endTime = val
    },
    // 改变页码
    setCurrent(val) {
      this.loading = true
      this.page = val
      loginLogPage({
        current: val,
        size: this.pageSize,
        userName: this.formCustom.userName,
        startTime: this.formCustom.startTime,
        endTime: this.formCustom.endTime
      }).then((res) => {
        this.changeData(res)
      })
    },
    // 改变每页条数
    setPage(val) {
      this.loading = true
      this.pageSize = val
      loginLogPage({
        current: 1,
        size: this.pageSize,
        userName: this.formCustom.userName,
        startTime: this.formCustom.startTime,
        endTime: this.formCustom.endTime
      }).then((res) => {
        this.changeData(res)
        this.$refs['pages'].currentPage = 1 // 分页变成第一页
      })
    },
    // 删除
    remove(id) {
      this.$Modal.confirm({
        title: '确认删除？',
        onOk: () => {
          loginLogDelete(id).then((res) => {
            if (res.data.success === false) {
              this.$Message.warning(res.data.msg)
            } else {
              this.$Message.success(res.data.msg)
            }
            this.init()
          }).catch(() => {
          })
        },
        onCancel: () => {
          this.$Message.info('已取消删除')
        }
      })
    },
    // 清空
    cleanAll() {
      this.$Modal.confirm({
        title: '确认清空？',
        onOk: () => {
          loginLogClean().then((res) => {
            if (res.data.success === false) {
              this.$Message.warning(res.data.msg)
            } else {
              this.$Message.success(res.data.msg)
            }
            this.init()
          }).catch(() => {
          })
        },
        onCancel: () => {
          this.$Message.info('已取消清空')
        }
      })
    }
  }
}
</script>
